document.addEventListener('shopify:section:select', function(e) {
  const html = document.querySelector('html');
  let previewTag = false;
  if(e.target.querySelector('nav-drawer')) {
    const navDrawer = e.target.querySelector('nav-drawer');
    navDrawer.open(e);
    previewTag = 'nav-drawer';
  }
  else if(e.target.querySelector('cart-drawer')) {
    const cartDrawer = e.target.querySelector('cart-drawer');
    cartDrawer.open();
    previewTag = 'cart-drawer';
  }
  else if(e.target.querySelector('password-drawer')) {
    const passwordDrawer = e.target.querySelector('password-drawer');
    passwordDrawer.open();
    previewTag = 'password-drawer';
  }
  closePreview(previewTag, e);
  if(previewTag) {
    html.setAttribute('theme-preview-section', previewTag);
  }
});

function closePreview(tag, e) {
  const html = document.querySelector('html');
  if(html.hasAttribute('theme-preview-section')) {
    const preview = html.getAttribute('theme-preview-section');
    if(preview == tag) {
      return false;
    }
    else if(preview == 'nav-drawer') {
      document.querySelector('nav-menu').close(e);
    }
    else if(preview == 'cart-drawer') {
      document.querySelector('cart-drawer').close();
    }
    else if(preview == 'password-drawer') {
      document.querySelector('password-drawer').close();
    }
    html.removeAttribute('theme-preview-section');
  }
}

document.addEventListener('shopify:section:load', function(e) {
  if(e.target.querySelector('nav-menu')) {
    if(ScrollTrigger.getById(`${e.target.id}-sticky`)) {
      ScrollTrigger.getById(`${e.target.id}-sticky`).kill();
    }
    const nav = e.target.querySelector('nav-menu');
    nav.initiateSticky();
  }
})